import { NOTES_BACKGROUND_TIMER_STORAGE_KEY } from './constants';
import { NotesBackgroundStorageParams } from './types';

export class NotesBackgroundStorage<T> {
  constructor(public key: string) {}
  set = (value: T): T => {
    localStorage.setItem(this.key, JSON.stringify(value));
    return value;
  };

  get = (): T | null => {
    const storedTimeSignal = localStorage.getItem(this.key);
    if (!storedTimeSignal) {
      this.remove();
      return null;
    }
    try {
      return JSON.parse(storedTimeSignal) as T;
    } catch (e) {
      console.warn(e, 'Failed parsing data from local storage.');
      this.remove();
      return null;
    }
  };

  remove = (): void => {
    localStorage.removeItem(this.key);
  };
}

export const notesBackgroundStorage = new NotesBackgroundStorage<NotesBackgroundStorageParams>(
  NOTES_BACKGROUND_TIMER_STORAGE_KEY
);
